import React from 'react';
import { Button, Card, Typography } from 'antd';

const { Text } = Typography;

export interface WorkspaceRegistrySummaryProps {
  title: string;
  count: number;
  onOpenAll: () => void;
}

/**
 * Компактная карточка доступа к полному реестру (Drawer).
 */
export const WorkspaceRegistrySummary: React.FC<WorkspaceRegistrySummaryProps> = ({
  title,
  count,
  onOpenAll,
}) => (
  <Card
    size="small"
    styles={{
      body: { padding: '10px 12px' },
    }}
  >
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        flexWrap: 'wrap',
      }}
    >
      <div>
        <Text strong style={{ display: 'block', fontSize: 14 }}>
          {title}
        </Text>
        <Text type="secondary">{count} активных</Text>
      </div>
      <Button type="default" onClick={onOpenAll}>
        Открыть все
      </Button>
    </div>
  </Card>
);

export default WorkspaceRegistrySummary;
